import * as SearchParams from "search-params";
export function getFrameRate() {
    var params = SearchParams.parse(window.location.search.replace(/^\?/, ""));
    var fps = params.find(function (param) { return param.name === "fps"; });
    if (fps) {
        return fps.value;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/frame_rate.ts
// module id = 339
// module chunks = 1